export default class LampLayer extends Phaser.Group {
  constructor(game, scrollRatio, layerH, screenH) {
    super(game);

    this.scrollRatio = scrollRatio;
    this.layerH = layerH;
    this.screenH = screenH;

    this.lamp = this.game.make.image(900, this.layerH - 147, 'lamp');
    this.lamp.anchor.set(0.5, 1);

    this.addChild(this.lamp);
  }

  setScreenHeight(value) {
    this.m_screenH = value;
  }

  scroll(dx, y) {
    this.lamp.x -= dx * this.scrollRatio;
    this.y = -y * (this.layerH - this.screenH);

    //
    if (this.lamp.x + this.lamp.width < 0) {
      this.lamp.x += 1300;
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/LampLayer.js